import { Link, SectionMessage, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceEditor } from '../../../../../../../../contexts/invoiceEditorContext'
import { useInvoiceEditorForm } from '../../../../../../../../contexts/invoiceEditorFormContext'
import { InvoiceEditorView } from '../../../../../../../../enums/invoiceEditorView'
import { localeToLanguageBannerTKey } from './constants/localeToLanguageBannerTKey'

interface InvoiceLanguageChangePreviewBannerProps {
  onClose: () => void
}

export const InvoiceLanguageChangePreviewBanner = ({
  onClose,
}: InvoiceLanguageChangePreviewBannerProps): ReactElement | null => {
  const { t } = useTranslation()
  const { setView } = useInvoiceEditor()
  const { invoiceEditorForm } = useInvoiceEditorForm()

  const { watch } = invoiceEditorForm
  const locale = watch('language')

  const tInfoKey = localeToLanguageBannerTKey[locale]

  const handleCloseButtonClick = useCallback(() => onClose(), [onClose])

  const handleLinkClick = useCallback(() => {
    setView(InvoiceEditorView.Preview)
  }, [setView])

  if (!tInfoKey) {
    return null
  }

  return (
    <>
      <SectionMessage closable icon="info" onClose={handleCloseButtonClick} showIcon variant="info">
        {t(tInfoKey)}
        <Text as="span" inheritColor weight="bold">
          <Link onClick={handleLinkClick} underlined>
            {t('external_invoices.editor.form.invoice_language_change_preview_banner.link')}
          </Link>
        </Text>
      </SectionMessage>
      <Space size="s16" />
    </>
  )
}
